const truncateSentence = (sentence: string, length: number, endWith = '...'): string => {
  const trimmedSentence = sentence.trim();
  if (trimmedSentence.length <= length) {
    return trimmedSentence;
  }

  const shortSentence = trimmedSentence.substr(0, length);
  const index = shortSentence.lastIndexOf(' ', length);

  if (index > 0) {
    return shortSentence.substr(0, index) + endWith;
  }

  return shortSentence + endWith;
};

export default truncateSentence;
